// A CVI 2.1 inventory record carries a `sourceVehicles` array: one copy of the vehicle per
// incoming channel feeding CVI 2.1, each tagged with the `sourceConfigurationId` of the channel
// it came from. The BFF serves that array as the Inventory Records Service returned it, so the
// CVI 2.1 detail tab shows the real record.
//
// The comparison view has a single CVI 2.1 column, so it has to choose one copy. This module is
// the seam to change when the column needs to prefer a particular channel, or to show several.
// The BFF makes the same pick for the summary list row (`From<InventoryRecord> for
// NormalizedVehicleInfo` in backend-rust/src/api_backend/models.rs) so a row and the column it
// opens agree -- change one and you have to change the other.

/** The copy of the vehicle the comparison view should show for an inventory record. */
function comparisonSourceVehicle(record) {
  const sources = record?.sourceVehicles;
  if (!Array.isArray(sources) || sources.length === 0)
    return null;
  return sources[0];
}

/**
 * Adapts a loaded inventory record for DataCompare: the field map reads flat `sourceVehicle.*`
 * paths, so the picked copy is attached under that name. The record's own fields -- and its
 * untouched `sourceVehicles` -- are left as they are.
 */
export function pickComparisonSourceVehicle(cvi2Vehicle) {
  if (!cvi2Vehicle || !cvi2Vehicle.data)
    return cvi2Vehicle;

  return {
    ...cvi2Vehicle,
    data: {
      ...cvi2Vehicle.data,
      sourceVehicle: comparisonSourceVehicle(cvi2Vehicle.data),
    },
  };
}
